<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">Participantes</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn color="primary" @click="create" class="mb-4">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          :search="search"
          :rows-per-page-items="[10,20,30,{'text':'Todos','value':-1}]"
          class="elevation-1"
          :custom-filter="customizedFilter"  style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td v-if="!props.item.user_id">{{''}}</td>
            <td v-else-if="tasktemplate.company_id === $auth.user().company_id">{{ props.item.user.id_text+(props.item.connection_company ? ('('+props.item.connection_company.id_text+')') : '')}}</td>
            <td v-else-if="props.item.connection_company_id">{{ props.item.user.id_text+(props.item.connection_company_id === $auth.user().company_id ? '' : ('('+props.item.connection_company.id_text+')')) }}</td>
            <td v-else>{{ props.item.user.id_text+((' ('+tasktemplate.company.id_text+')'))}}</td>
            <td>{{ props.item.note }}</td>
            <td align="center" style="min-width: 110px">
              <v-btn icon class="mx-0" @click="editItem(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="dialogDelete(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" @keyup.native.esc="closeProcess(400)" @keyup.native.ctrl.enter="save()" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12 md6>
                  <p-select-user ref="userIllis" v-model="selectedUser" :rules="requiredRule(translate('table.' + entity + '.field.user_id'))" :users="users" :label="translate('table.' + entity + '.field.user_id')" @input="changeResponsible" :itemsNotShow="itemsNotShow"></p-select-user>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field :label="translate('table.' + entity + '.field.note')"
                                v-model="editedItem.note" name="note"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="save()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="closeProcess(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import PConfirm from './../shared/PConfirm'
  import PSelectUser from './../shared/PSelectUser'

  export default {
    mixins: [crud, rules],
    components: {PConfirm, PSelectUser},
    data: () => ({
      entity: 'tasktemplate_user',
      selectedUser: null
    }),
    name: 'User',
    props: {
      tasktemplate: {
        type: Object,
        default: function () { return {} }
      },
      // caso venha users do componente acima usa eles
      users: {
        type: Array,
        default: function () { return [] }
      }
    },
    created () {
      this.items = this.tasktemplate['users'] ? this.tasktemplate['users'] : []
      this.editedItem = {tasktemplate_id: this.tasktemplate.id, connection_id: '', connection_company_id: ''}
      this.defaultItem = {tasktemplate_id: this.tasktemplate.id, connection_id: '', connection_company_id: ''}
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
    },
    methods: {
      closeProcess (time) {
        this.close(time)
        this.changeResponsible(null)
      },
      afterDelete (res) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'users',
          responseEvent: 'deleteSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
        this.changeResponsible(null)
      },
      afterInsert (res) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'users',
          responseEvent: 'addSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
        this.changeResponsible(null)
      },
      afterUpdate (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'users',
          responseEvent: 'editSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
        this.changeResponsible(null)
      },
      afterEditItem () {
        // Caso tenha usuário no momento de editar cria a estrutura do usuário para o PSelectUser aceitar
        if (this.editedItem.user_id) {
          let userIndex = {
            company_id: this.editedItem.connection_company_id ? this.editedItem.connection_company_id : this.$auth.user().company_id,
            company_id_text: this.editedItem.connection_company ? this.editedItem.connection_company.id_text : null,
            connection_id: this.editedItem.connection_id,
            email: this.editedItem.user.email,
            id: `${this.editedItem.user_id}-${this.editedItem.connection_company_id ? this.editedItem.connection_company_id : this.editedItem.company_id}`,
            id_text: `${this.editedItem.user.id_text} (${this.editedItem.user.email})`,
            logo_path: this.editedItem.connection_company ? this.editedItem.connection_company.logo_path : null,
            photo_path: this.editedItem.user.photo_path,
            user_id: this.editedItem.user_id,
            connection_status: 2
          }
          if (userIndex) {
            this.selectedUser = userIndex
          }
        }
      },
      changeResponsible (val) {
        if (val && val.id !== null && val.id !== {}) {
          this.selectedUser = val
          this.editedItem.user_id = val.user_id
          this.editedItem.connection_id = val.connection_id
          this.editedItem.connection_company_id = (val.company_id !== this.$auth.user().company_id ? val.company_id : null)
        } else {
          this.selectedUser = null
          this.editedItem.user_id = null
          this.editedItem.connection_id = null
          this.editedItem.connection_company_id = null
        }
      }
    },
    computed: {
      // Valores que já foram incluidos na lista, para que o PSelectUser não mostre eles
      itemsNotShow: function () {
        var items = []
        this.items.map((val) => {
          items.push(`${val.user_id}-${val.connection_company_id ? val.connection_company_id : this.$auth.user().company_id}`)
        })
        return items
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'user.id_text', width: '50%'},
          {text: this.translate('table.' + this.entity + '.field.note'), value: 'note', width: '30%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TemplateUser.vue